// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2dyud","copy":"styles_copy__2Y7a-","buttons":"styles_buttons__2Wjkl","warning":"styles_warning__Jbe2P"};